import { useSyncExternalStore } from 'react';

const REPORT_HASH_PREFIX = '#/reporte/';
const REPORT_ID_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;

export const reportHash = (reportId: string): string =>
  `${REPORT_HASH_PREFIX}${encodeURIComponent(reportId)}`;

/** Id del reporte de `#/reporte/<id>`; `null` en cualquier otra ruta o con un id mal formado. */
export function reportIdOfHash(hash: string): string | null {
  if (!hash.startsWith(REPORT_HASH_PREFIX)) return null;
  let id: string;
  try {
    id = decodeURIComponent(hash.slice(REPORT_HASH_PREFIX.length));
  } catch {
    return null;
  }
  return REPORT_ID_PATTERN.test(id) ? id : null;
}

/** Enlace absoluto al reporte, en la misma direccion desde la que se sirve la app. */
export const reportUrl = (reportId: string, location: Location = window.location): string =>
  `${location.origin}${location.pathname}${location.search}${reportHash(reportId)}`;

const subscribe = (listener: () => void) => {
  window.addEventListener('hashchange', listener);
  return () => {
    window.removeEventListener('hashchange', listener);
  };
};

/** Reporte abierto por la URL actual (se actualiza con atras/adelante del navegador). */
export function useReportRoute(): string | null {
  return useSyncExternalStore(
    subscribe,
    () => reportIdOfHash(window.location.hash),
    () => null,
  );
}
